import { bool, func, string } from 'prop-types';
import React, { memo, useState } from 'react';
import { useIntl } from 'react-intl';
import { useCartState } from '../../../contexts/cart';
import isObjectEmpty from '../../../aem-core-components/utils/isObjectEmpty';
import Error from '../../../resources/images/error.svg';
import LocationAutocomplete from '../../global/modules/location-autocomplete';
import {
    getlatLongByAddress,
    getLocationsDetailsByPlaceId
} from '../../global/modules/location-autocomplete/api/getLocations';
import { setLocationInStorage } from '../../location/storesLocationFunctions';
import './dstSearchForm.scss';
import { STORAGE_CONFIG } from '../../../constants/storageConfig';
import { getCompanyId } from '../../global/utils/commonUtils';

const DstSearchForm = props => {
    const {
        placeholderText,
        wrapClass,
        getStores,
        isCurrentLocationAllowed,
        currentAddress,
        getCustomCountryCode,
        setIsUserLocationUsed,
        isUserLocationUsed,
        setIsCurrentLocationAllowed,
        setuserLatLong,
        userAddress,
        setUserAddress,
        locationDeniedError,
        setLocationDeniedError,
        onClearingAddress
    } = props;
    const [streetAddress, setStreetAddress] = useState('');
    const [, cartDispatch] = useCartState();
    const intl = useIntl();
    const [streetError, setStreetError] = useState('');
    const usDefaultResponse = intl.formatMessage({ id: 'geocode-default-us-response' });
    const canadaDefaultResponse = intl.formatMessage({
        id: 'geocode-default-ca-response'
    });
    const handleSearchSubmit = event => {
        event.preventDefault();
    };
    const onAutoSelectAddress = async placeId => {
        setLocationDeniedError(false);
        const responseFromPlaceDetails = await getLocationsDetailsByPlaceId(placeId);
        if (responseFromPlaceDetails?.error || isObjectEmpty(responseFromPlaceDetails?.data?.result)) {
            setStreetError(intl.formatMessage({ id: 'cart-header:location-autocomplete-error-mesage-2' }));
            return;
        }
        const lat = responseFromPlaceDetails?.data?.result?.geometry?.location?.lat || '';
        const long = responseFromPlaceDetails?.data?.result?.geometry?.location?.lng || '';
        cartDispatch({ type: 'beginLoading' });
        getStores(lat, long);
        setIsUserLocationUsed(true);
        setIsCurrentLocationAllowed(false);
        setuserLatLong({ lat: lat, long: long });
        setUserAddress(responseFromPlaceDetails?.data?.result?.formattedAddress);
        setLocationInStorage({
            lat,
            long,
            formattedAddress: responseFromPlaceDetails?.data?.result?.formattedAddress
        });
    };

    const onSearchIconClick = async autocompleteText => {
        setLocationDeniedError(false);
        setStreetAddress(autocompleteText);
        if (autocompleteText === '') {
            setStreetAddress('');
            onClearingAddress();
        }
        if (autocompleteText !== '') {
            const companyID = getCompanyId();
            const responseFromGeocode = await getlatLongByAddress(companyID, autocompleteText, false, false);
            const formattedAddressResponse = responseFromGeocode?.data?.results?.[0]?.formattedAddress;
            if (
                responseFromGeocode?.error ||
                responseFromGeocode?.data?.results?.length == 0 ||
                isObjectEmpty(responseFromGeocode?.data)
            ) {
                setStreetError(intl.formatMessage({ id: 'cart-header:location-autocomplete-error-mesage-2' }));
                return false;
            } else if (
                formattedAddressResponse == usDefaultResponse ||
                formattedAddressResponse == canadaDefaultResponse
            ) {
                setStreetError(intl.formatMessage({ id: 'cart-header:location-autocomplete-error-mesage-2' }));
                return false;
            } else {
                let lat = responseFromGeocode?.data?.results[0]?.geometry?.location?.lat || '';
                let long = responseFromGeocode?.data?.results[0]?.geometry?.location?.lng || '';
                if (!lat || !long) {
                    setStreetError(intl.formatMessage({ id: 'cart-header:location-autocomplete-error-mesage-2' }));
                    return false;
                }

                //TODO search api calls

                cartDispatch({ type: 'beginLoading' });
                getStores(lat, long);
                setIsUserLocationUsed(true);
                setIsCurrentLocationAllowed(false);
                setuserLatLong({ lat: lat, long: long });
                setUserAddress(responseFromGeocode?.data?.results[0]?.formattedAddress);
                setLocationInStorage({
                    lat,
                    long,
                    formattedAddress: responseFromGeocode?.data?.results[0]?.formattedAddress
                });
                return true;
            }
        }
    };

    const setPrefilledAddress = () => {
        if (isUserLocationUsed) {
            return userAddress;
        } else if (isCurrentLocationAllowed) {
            return currentAddress;
        }
        return streetAddress || '';
    };
    const handleReset = () => {
        setStreetAddress('');
        setIsUserLocationUsed(false);
        onClearingAddress();
    };
    return (
        <>
            <form role="search" className={`form-search ${wrapClass}`} onSubmit={handleSearchSubmit}>
                <div
                    className={
                        locationDeniedError
                            ? `input-group input-group--append`
                            : `input-group input-group--append location__search dst__search`
                    }>
                    <LocationAutocomplete
                        onSelectAddress={onAutoSelectAddress}
                        showSearchIcon={true}
                        prefilledAddress={setPrefilledAddress()}
                        onSearchIconClick={val => onSearchIconClick(val)}
                        selectedAddress={val => {
                            setStreetAddress(val);
                            setIsUserLocationUsed(false);
                        }}
                        onReset={handleReset}
                        showResetBtn={true}
                        customParentClass={'location__search_div'}
                        placeholderText={placeholderText}
                        customCountryCode={getCustomCountryCode}
                        locationAutocompleteWrapper={'location-autocomplete--page'}
                        errorMessage={streetError}
                        onClearingAddress={onClearingAddress}
                        showAddressLineOneOnly={false}
                        isLocationAvailable={false}
                        baseSuggesstionsByUserLocation={true}
                    />
                </div>
                {locationDeniedError && (
                    <div className="errorTextContainer">
                        <Error />
                        <p className="errorText">{intl.formatMessage({ id: 'location-denied-error' })}</p>
                    </div>
                )}
            </form>
        </>
    );
};
DstSearchForm.propTypes = {
    placeholderText: string,
    locationDeniedError: bool,
    wrapClass: string,
    setLocationDeniedError: func
};

DstSearchForm.defaultProps = {
    placeholderText: '',
    locationDeniedError: false,
    wrapClass: '',
    setLocationDeniedError: () => {}
};
export default memo(DstSearchForm);
